import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-navy-950 py-8 px-4 border-t border-navy-900 text-center" data-id="element-53">
        <p className="text-cream-100/40 font-body text-sm" data-id="element-54">
          &copy; {new Date().getFullYear()} S.O.S. Sueño Infantil. Todos los
          derechos reservados.
        </p>
        <p className="text-cream-100/30 font-body text-xs mt-2 max-w-2xl mx-auto" data-id="element-55">
          Este producto no sustituye el consejo médico profesional. Siempre
          consulta con tu pediatra antes de implementar cambios en la rutina de
          tu bebé.
        </p>
        <div className="mt-4 flex justify-center gap-6" data-id="element-56">
          <button onClick={() => setActiveModal('privacy')} className="text-cream-100/40 hover:text-amber-400 font-body text-xs underline underline-offset-2 transition-colors" data-id="element-57">
            Política de Privacidad
          </button>
          <button onClick={() => setActiveModal('terms')} className="text-cream-100/40 hover:text-amber-400 font-body text-xs underline underline-offset-2 transition-colors" data-id="element-58">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      <AnimatePresence data-id="element-59">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-60">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3
        }} className="bg-navy-900 border border-navy-700 rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-61">
              <div className="sticky top-0 bg-navy-900 border-b border-navy-700 px-6 py-4 flex items-center justify-between rounded-t-2xl" data-id="element-62">
                <h3 className="text-xl font-display font-bold text-cream-50" data-id="element-63">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="text-cream-100/50 hover:text-cream-50 transition-colors p-1" data-id="element-64">
                  <XIcon className="w-5 h-5" data-id="element-65" />
                </button>
              </div>

              <div className="px-6 py-6 text-cream-100/80 font-body text-sm leading-relaxed space-y-4" data-id="element-66">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-67" /> : <TermsContent data-id="element-68" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-cream-100/50 text-xs" data-id="element-69">
        Última actualización: Marzo 2026
      </p>

      <h4 className="text-lg font-display font-bold text-cream-50 pt-2" data-id="element-70">
        1. Información que Recopilamos
      </h4>
      <p data-id="element-71">
        Al adquirir nuestro producto digital, recopilamos la información
        necesaria para procesar tu compra, incluyendo tu nombre y dirección de
        correo electrónico. No recopilamos información de tarjetas de crédito
        directamente; todos los pagos son procesados de forma segura por nuestro
        procesador de pagos externo.
      </p>

      <h4 className="text-lg font-display font-bold text-cream-50 pt-2" data-id="element-72">
        2. Uso de la Información
      </h4>
      <p data-id="element-73">Utilizamos tu información personal exclusivamente para:</p>
      <ul className="list-disc list-inside space-y-1 pl-2" data-id="element-74">
        <li data-id="element-75">Entregar el producto digital que adquiriste.</li>
        <li data-id="element-76">Enviarte actualizaciones relacionadas con tu compra.</li>
        <li data-id="element-77">Responder a tus consultas o solicitudes de soporte.</li>
      </ul>

      <h4 className="text-lg font-display font-bold text-cream-50 pt-2" data-id="element-78">
        3. Protección de Datos
      </h4>
      <p data-id="element-79">
        Implementamos medidas de seguridad razonables para proteger tu
        información personal contra acceso no autorizado, alteración o
        destrucción. Sin embargo, ningún método de transmisión por Internet es
        100% seguro.
      </p>

      <h4 className="text-lg font-display font-bold text-cream-50 pt-2" data-id="element-80">
        4. Compartir Información
      </h4>
      <p data-id="element-81">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros. Esto no incluye a terceros de confianza que nos ayudan a
        operar nuestro sitio web o a procesar pagos, siempre que dichas partes
        acuerden mantener esta información confidencial.
      </p>

      <h4 className="text-lg font-display font-bold text-cream-50 pt-2" data-id="element-82">
        5. Cookies
      </h4>
      <p data-id="element-83">
        Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
        navegación. Puedes configurar tu navegador para rechazar cookies, aunque
        esto podría afectar la funcionalidad del sitio.
      </p>

      <h4 className="text-lg font-display font-bold text-cream-50 pt-2" data-id="element-84">
        6. Tus Derechos
      </h4>
      <p data-id="element-85">
        Tienes derecho a solicitar acceso, corrección o eliminación de tus datos
        personales en cualquier momento. Para ejercer estos derechos, puedes
        comunicarte con nosotros a través de los canales disponibles en nuestro
        sitio.
      </p>

      <h4 className="text-lg font-display font-bold text-cream-50 pt-2" data-id="element-86">
        7. Cambios a esta Política
      </h4>
      <p data-id="element-87">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Los cambios serán publicados en esta página con la
        fecha de actualización correspondiente.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-cream-100/50 text-xs" data-id="element-88">
        Última actualización: Marzo 2026
      </p>

      <h4 className="text-lg font-display font-bold text-cream-50 pt-2" data-id="element-89">
        1. Aceptación de los Términos
      </h4>
      <p data-id="element-90">
        Al acceder y realizar una compra en este sitio web, aceptas cumplir con
        estos términos y condiciones de uso. Si no estás de acuerdo con alguno
        de estos términos, te recomendamos no utilizar nuestros servicios.
      </p>

      <h4 className="text-lg font-display font-bold text-cream-50 pt-2" data-id="element-91">
        2. Producto Digital
      </h4>
      <p data-id="element-92">
        S.O.S. Sueño Infantil es un producto digital informativo en formato PDF.
        El contenido proporcionado es de carácter educativo y no constituye
        consejo médico profesional. Siempre consulta con tu pediatra antes de
        implementar cambios en la rutina de sueño de tu bebé.
      </p>

      <h4 className="text-lg font-display font-bold text-cream-50 pt-2" data-id="element-93">
        3. Entrega del Producto
      </h4>
      <p data-id="element-94">
        Una vez completado el pago, recibirás acceso instantáneo al producto
        digital. El enlace de descarga será enviado a la dirección de correo
        electrónico proporcionada durante la compra.
      </p>

      <h4 className="text-lg font-display font-bold text-cream-50 pt-2" data-id="element-95">
        4. Política de Reembolso
      </h4>
      <p data-id="element-96">
        Debido a la naturaleza digital del producto y su entrega inmediata,
        todas las ventas son finales. No ofrecemos reembolsos una vez que el
        producto ha sido entregado y descargado.
      </p>

      <h4 className="text-lg font-display font-bold text-cream-50 pt-2" data-id="element-97">
        5. Propiedad Intelectual
      </h4>
      <p data-id="element-98">
        Todo el contenido incluido en S.O.S. Sueño Infantil, incluyendo textos,
        gráficos, imágenes y diseño, es propiedad exclusiva del creador. Queda
        prohibida la reproducción, distribución o reventa del material sin
        autorización previa por escrito.
      </p>

      <h4 className="text-lg font-display font-bold text-cream-50 pt-2" data-id="element-99">
        6. Limitación de Responsabilidad
      </h4>
      <p data-id="element-100">
        Los resultados pueden variar de un bebé a otro. No garantizamos
        resultados específicos ya que cada niño es diferente. El producto ofrece
        estrategias basadas en evidencia, pero la implementación y los
        resultados dependen de múltiples factores individuales.
      </p>

      <h4 className="text-lg font-display font-bold text-cream-50 pt-2" data-id="element-101">
        7. Uso Apropiado
      </h4>
      <p data-id="element-102">
        Este producto está diseñado para bebés sanos de 4 a 24 meses. Si tu bebé
        tiene alguna condición médica que pueda afectar su sueño, consulta con
        un profesional de la salud antes de aplicar cualquier técnica descrita
        en el material.
      </p>

      <h4 className="text-lg font-display font-bold text-cream-50 pt-2" data-id="element-103">
        8. Modificaciones
      </h4>
      <p data-id="element-104">
        Nos reservamos el derecho de modificar estos términos y condiciones en
        cualquier momento. Las modificaciones entrarán en vigor inmediatamente
        después de su publicación en el sitio web.
      </p>
    </>;
}